import {InlineTextSegment} from '../types/ChatModal.types';

export const parseInlineTextSegments = (value: string): InlineTextSegment[] => {
  if (!value) {
    return [];
  }

  const segments: InlineTextSegment[] = [];
  let cursor = 0;

  while (cursor < value.length) {
    const openingIndex = value.indexOf('**', cursor);

    if (openingIndex === -1) {
      segments.push({
        text: value.slice(cursor),
        isBold: false,
      });
      break;
    }

    if (openingIndex > cursor) {
      segments.push({
        text: value.slice(cursor, openingIndex),
        isBold: false,
      });
    }

    const closingIndex = value.indexOf('**', openingIndex + 2);

    if (closingIndex === -1) {
      segments.push({
        text: value.slice(openingIndex),
        isBold: false,
      });
      break;
    }

    if (closingIndex === openingIndex + 2) {
      cursor = closingIndex + 2;
      continue;
    }

    segments.push({
      text: value.slice(openingIndex + 2, closingIndex),
      isBold: true,
    });
    cursor = closingIndex + 2;
  }

  return segments.filter(segment => segment.text.length > 0);
};
